
import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import { Prop, Emit, Model, Watch } from "vue-property-decorator";
import api from "@/api";
import HelperModel from "@/models/HelperModel";

@Component({
  components: {},
})
export default class FileInput extends Vue {
  @Model("input", { type: [String, Number, File] }) value!: String | Number | File;
  @Prop() rules!: string;
  @Prop() name!: string;
  @Prop() type!: string;
  @Prop() src!: string;
  @Prop() accept!: string;
  @Prop() maxSizeImgInKb!: number;
  @Prop() maxSizeVideoInKb!: number;
  @Prop() isPath!: boolean;

  @Ref() fileChoose!: HTMLElement;

  helper: HelperModel = new HelperModel();
  onActive = true;
  onPreview = false;
  onPreviewVideo = false;
  modValue: number | string | null = null;
  srcPreview: string | ArrayBuffer | null = "";
  fileImage: File | null = null;
  displaySrc: string | ArrayBuffer | null = "";

  created() {
    this.initializeValue();
  }

  initializeValue() {
    if (this.value) {
      this.modValue = this.value as string;
      if (typeof this.value === 'string' && (this.value.startsWith('http') || this.value.startsWith('/'))) {
        this.displaySrc = this.value;
        this.onPreview = this.isImageUrl(this.value);
        this.onPreviewVideo = this.isVideoUrl(this.value);
        this.onActive = false;
      }
    }
  }

  isImageUrl(url: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(url);
  }

  isVideoUrl(url: string): boolean {
    return /\.(mp4|mkv|mov)$/i.test(url);
  }

  onElementClick() {
    if (this.fileChoose) {
      this.fileChoose.click();
    }
  }

  onSelectFile(payload: Event) {
    const input = payload.target as HTMLInputElement;
    const files = input.files;
    if (files && files[0]) {
      const reader = new FileReader();
      if (
        files[0].type === "video/mp4" ||
        files[0].type === "video/mkv" ||
        files[0].type === "video/mov"
      ) {
        if (this.fileMaxImage(files[0].size, this.maxSizeVideoInKb)) {
          reader.onload = (payload) => {
            if (payload.target) {
              this.displaySrc = payload.target.result;
              this.fileImage = files[0];
              return this.uploadFile();
            }
          };
          reader.readAsDataURL(files[0]);
          this.$emit("input", files[0]);
          this.onPreviewVideo = true;
          this.onPreview = false;
          this.onActive = false;
        }
      } else if (
        files[0].type === "image/png" ||
        files[0].type === "image/jpg" ||
        files[0].type === "image/jpeg"
      ) {
        if (this.fileMaxImage(files[0].size, this.maxSizeImgInKb)) {
          reader.onload = (payload) => {
            if (payload.target) {
              this.displaySrc = payload.target.result;
              this.fileImage = files[0];
              return this.uploadFile();
            }
          };
          reader.readAsDataURL(files[0]);
          this.$emit("input", files[0]);
          this.onPreview = true;
          this.onPreviewVideo = false;
          this.onActive = false;
        }
      }
    }
  }

  uploadFile(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.fileImage) {
        api.helper
          .uploadFile(this.fileImage, this.fileImage.name)
          .then((response) => {
            this.helper = Object.assign({}, response.data);
            this.modValue = this.isPath ? this.helper.media_url : this.helper.media_id;
            resolve(response);
          })
          .catch((err) => {
            this.$swal("Error", "Failed to upload file. Please try again.", "error");
            reject(new Error(err));
          });
      }
    });
  }

  fileMaxImage(size: number, max: number): boolean {
    const maxFile = max * 1000;
    return size <= maxFile;
  }

  @Watch("value", { immediate: true })
  onValueChange(newValue: string | number | File) {
    if (newValue !== this.modValue) {
      this.initializeValue();
    }
  }

  @Watch("modValue")
  onModValueChange() {
    this.input(this.modValue);
  }

  @Emit()
  input(value: string | number | null) {
    return value;
  }
}
